var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{staticClass:"button is-small is-ghost",on:{"click":_vm.toggleMask}},[_c('fa-icon',{attrs:{"icon":_vm.masked ? 'eye-slash' : 'eye',"title":_vm.$gettext(_vm.masked ? 'Masked' : 'Visible')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }